<div class="main">
  <div class="filterContainer">
    <app-AutoDropdown
      [(SelectedValue)]="selectedCategory"
      [onChangeFunction]="onChangeFunction"
      [items]="courseCategories"
      displayProperty="name"
      label="Søg Kategori"
      >
    </app-AutoDropdown>
  </div>
  <div class="button-container">
    <button
      mat-flat-button
      color="accent"
      class="generalBtn"
      (click)="createNewCourse()"
      >
      Nyt Kursus
    </button>
  </div>

  @if (!isHistory) {
    <div class="list-container">
      <lib-list-view
        #listView
        [headerList]="headerList"
        (rowClick)="openCourseDialog($event)"
        [filterFunction]="filterFunction"
        [extraBurgerMenuOptions]="extraBurgerMenuOptions"
        >
      </lib-list-view>
    </div>
  }

  @if (isHistory) {
    <div class="list-container">
      <lib-list-view
        #logListView
        [headerList]="logHeaderList"
        [filterFunction]="filterFunction"
        [extraBurgerMenuOptions]="extraBurgerMenuOptions"
        >
      </lib-list-view>
    </div>
  }
</div>
